export default __webpack_public_path__ + "static/media/jewi.7ca0fb4b.jpg";